import React from "react";

export function TickWithGreenBgIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.428571"
          y="0.428571"
          width="23.1429"
          height="23.1429"
          rx="11.5714"
          fill="#008367"
        />
        <rect
          x="0.428571"
          y="0.428571"
          width="23.1429"
          height="23.1429"
          rx="11.5714"
          stroke="#008367"
          stroke-width="0.857143"
        />
        <g clip-path="url(#clip0_129_1593)">
          <path
            d="M9.96411 14.8292L7.13447 11.9995L6.1709 12.9563L9.96411 16.7495L18.107 8.60669L17.1502 7.6499L9.96411 14.8292Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_129_1593">
            <rect
              width="16.2857"
              height="16.2857"
              fill="white"
              transform="translate(3.85742 3.85693)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
